import { api } from './api.config'

import request from '@/utils/request'

export default {
  auditInvoicing: {
    saveAuditInvoiceing (data) {
      return request({
        url: api.auditInvoicing.saveAuditInvoiceing,
        method: 'post',
        data
      })
    },
    getSelectGoods (data) {
      return request({
        url: api.auditInvoicing.getSelectGoods,
        method: 'get',
        data
      })
    }
  },
  apply: {
    save (data) {
      return request({
        url: api.apply.save,
        method: 'post',
        data
      })
    },
    taxControlInvoicing (data) {
      return request({
        url: api.apply.taxControlInvoicing,
        method: 'post',
        data
      })
    },
    allElectricInvoicing (data) {
      return request({
        url: api.apply.allElectricInvoicing,
        method: 'post',
        data
      })
    },
    getAllElectricInfo (data) {
      return request({
        url: api.apply.getAllElectricInfo,
        method: 'get',
        data
      })
    },
    edit (data) {
      return request({
        url: api.apply.edit,
        method: 'post',
        data
      })
    },
    getInvoicePage (data) {
      return request({
        url: api.apply.getInvoicePage,
        method: 'post',
        data
      })
    },
    redInvoice (data) {
      return request({
        url: api.apply.redInvoice,
        method: 'post',
        data
      })
    },
    getInvoiceResult (data) {
      return request({
        url: api.apply.getInvoiceResult,
        method: 'get',
        data
      })
    },
    getInvoiceInfByCodyNo (data) {
      return request({
        url: api.apply.getInvoiceInfByCodyNo,
        method: 'get',
        data
      })
    },
    delete (data) {
      return request({
        url: api.apply.delete,
        method: 'get',
        data
      })
    },
    batchDelete (data) {
      return request({
        url: api.apply.batchDelete,
        method: 'post',
        data
      })
    },
    getApplyList (data) {
      return request({
        url: api.apply.getApplyList,
        method: 'post',
        data
      })
    },
    getMobileApplyList (data) {
      return request({
        url: api.apply.getMobileApplyList,
        method: 'post',
        data
      })
    },
    getApplyDetail (data) {
      return request({
        url: api.apply.getApplyDetail,
        method: 'get',
        data
      })
    },
    getDetails (data) {
      return request({
        url: api.apply.getDetails,
        method: 'get',
        data
      })
    },
    preview (data) {
      return request({
        url: api.apply.preview,
        method: 'get',
        data
      })
    },
    sendEmail (data) {
      return request({
        url: api.apply.sendEmail,
        method: 'post',
        data
      })
    },
    createEmail (data) {
      return request({
        url: api.apply.createEmail,
        method: 'post',
        data
      })
    },
    applyRedOrCancel (data) {
      return request({
        url: api.apply.applyRedOrCancel,
        method: 'post',
        data
      })
    },
    getInvoiceList (data) {
      return request({
        url: api.apply.getInvoiceList,
        method: 'get',
        data
      })
    },
    getInvoiceInfo (data) {
      return request({
        url: api.apply.getInvoiceInfo,
        method: 'get',
        data
      })
    }
  },
  statistics: {
    getStatistics (data) {
      return request({
        url: api.statistics.getStatistics,
        method: 'get',
        data
      })
    },
    getStatsList (data) {
      return request({
        url: api.statistics.getStatsList,
        method: 'post',
        data
      })
    },
    getStatsMobildList (data) {
      return request({
        url: api.statistics.getStatsMobildList,
        method: 'post',
        data
      })
    },
    getStatisticsMonth (data) {
      return request({
        url: api.statistics.getStatisticsMonth,
        method: 'get',
        data
      })
    }
  },
  express: {
    expressTrackList (data) {
      return request({
        url: api.express.expressTrackList,
        method: 'post',
        data
      })
    }
  },
  customer: {
    getCustomersByName (data) {
      return request({
        url: api.customer.getCustomersByName,
        method: 'get',
        data,
        headers: { 'SYS-FUNCTION-CODE': 'SELLER_BASIC' }
      })
    },
    getUserDept (data) {
      return request({
        url: api.customer.getUserDept,
        method: 'get',
        data
      })
    },
    getDefaultReceiver (data) {
      return request({
        url: api.customer.getDefaultReceiver,
        method: 'get',
        data
      })
    },
    getReceiverList (data) {
      return request({
        url: api.customer.getReceiverList,
        method: 'get',
        data
      })
    },
    getReceiverInfo (data) {
      return request({
        url: api.customer.getReceiverInfo,
        method: 'get',
        data
      })
    },
    editReceiver (data) {
      return request({
        url: api.customer.editReceiver,
        method: 'post',
        data
      })
    },
    deleteReceiver (data) {
      return request({
        url: api.customer.deleteReceiver,
        method: 'delete',
        data
      })
    }
  },
  goods: {
    getGoodsList (data) {
      return request({
        url: api.goods.getGoodsList,
        method: 'get',
        data
      })
    },
    getGoodsInfo (data, params) {
      return request({
        url: api.goods.getGoodsInfo,
        method: 'get',
        data,
        params
      })
    },
    addGoods (data) {
      return request({
        url: api.goods.addGoods,
        method: 'post',
        data
      })
    },
    setDefaultGoods (data) {
      return request({
        url: api.goods.setDefaultGoods,
        method: 'post',
        data
      })
    },
    getGoodsCode (data) {
      return request({
        url: api.goods.getGoodsCode,
        method: 'get',
        data
      })
    },
    editGoods (data) {
      return request({
        url: api.goods.editGoods,
        method: 'put',
        data
      })
    },
    getRevenueCodeByGoodsName (data) {
      return request({
        url: api.goods.getRevenueCodeByGoodsName,
        method: 'get',
        data
      })
    }
  },
  taker: {
    getDefaultTaker (data) {
      return request({
        url: api.taker.getDefaultTaker,
        method: 'get',
        data
      })
    }
  },
  allElectricQrCode: {
    getQrcode (data) {
      return request({
        url: api.allElectricQrCode.getQrcode,
        method: 'get',
        data
      })
    },
    getAuthInfo (data) {
      return request({
        url: api.allElectricQrCode.getAuthInfo,
        method: 'get',
        data
      })
    },
    getAuthResult (data) {
      return request({
        url: api.allElectricQrCode.getAuthResult,
        method: 'post',
        data
      })
    }
  },
  allElectricLogin: {
    getAuthInfo (data) {
      return request({
        url: api.allElectricLogin.getAuthInfo,
        method: 'get',
        data
      })
    },
    getMsgLoginResult (data) {
      return request({
        url: api.allElectricLogin.getMsgLoginResult,
        method: 'get',
        data
      })
    },
    asyncAutonomousLogin (data) {
      return request({
        url: api.allElectricLogin.asyncAutonomousLogin,
        method: 'post',
        data
      })
    },
    asyncSubmitSms (data) {
      return request({
        url: api.allElectricLogin.asyncSubmitSms,
        method: 'post',
        data
      })
    },
    asyncGetQrCodeStatus (data) {
      return request({
        url: api.allElectricLogin.asyncGetQrCodeStatus,
        method: 'post',
        data
      })
    }
  },
  blank: {
    getBlankList (data) {
      return request({
        url: api.blank.getBlankList,
        method: 'get',
        data
      })
    },
    changeDevice (data) {
      return request({
        url: api.blank.changeDevice,
        method: 'get',
        data
      })
    },
    queryOnLine (data) {
      return request({
        url: api.blank.queryOnLine,
        method: 'post',
        data
      })
    },
    syncBlankInvoiceAsync (data) {
      return request({
        url: api.blank.syncBlankInvoiceAsync,
        method: 'post',
        data
      })
    },
    getClearList (data) {
      return request({
        url: api.blank.getClearList,
        method: 'post',
        data
      })
    },
    reportRefreshTax (data) {
      return request({
        url: api.blank.reportRefreshTax,
        method: 'post',
        data
      })
    }
  }
}
